export type PromptQueueSnapshotEntries = Array<[queueKey: string, serverTurns: unknown[]]>;

export function promptQueueSnapshotEntries(queues: Record<string, unknown[]>): PromptQueueSnapshotEntries {
  return Object.entries(queues).filter((entry): entry is [string, unknown[]] => Array.isArray(entry[1]));
}
